<ion-content fullscreen class="full-bg">
  <app-fullscreen>
    <div class="container" header>
      <app-step-header
        [hideBack]="true"
        [hideProgress]="true">
      </app-step-header>
    </div>
    <div class="preface-slides" body>
      <swiper-container
        [modules]="swiperModules"
        [pagination]="steps.length > 1"
        (swiperslidechange)="onSlideWillChange()"
        #swiper>
        <swiper-slide *ngFor="let step of steps">
          <div class="modal-slide ion-padding">
            <ion-icon *ngIf="!!step.figure" [src]="step.figure | srcAssets:'icons'" class="xl ion-margin primary-icon"></ion-icon>
            <p class="ion-margin ion-text-left" [innerHTML]="step.message | translate"></p>
          </div>
        </swiper-slide>
      </swiper-container>
    </div>
    <div footer>
      <app-footer
        [position]="'block'"
        [tip]="completed ? endTip : startTip"
        [secondaryButton]="{ hidden: true }"
        [primaryButton]="{ icon: completed ? 'checkmark' : 'arrow-forward'}"
        (primaryClick)="toNextStep()">
      </app-footer>
    </div>
  </app-fullscreen>
</ion-content>
